/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import PropTypes from 'prop-types';

const LowersIcons = ({ width, height }) => {
  return (
    <svg
      className="animated"
      id="freepik_stories-lighthouse"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 500 500"
      version="1.1"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      css={css`
        max-width: ${width || '100%'};
        max-height: ${height || '100%'};
        height: ${height || '100%'};
        width: ${width || '100%'};
        display: inline-block;
      `}
    >
      <style
        dangerouslySetInnerHTML={{
          __html:
            'svg#freepik_stories-lighthouse:not(.animated) .animable {opacity: 0;}svg#freepik_stories-lighthouse.animated #freepik--background-complete--inject-2 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideDown;animation-delay: 0s;}svg#freepik_stories-lighthouse.animated #freepik--Sea--inject-2 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomIn;animation-delay: 0s;}svg#freepik_stories-lighthouse.animated #freepik--Lighthouse--inject-2 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideRight;animation-delay: 0s;}svg#freepik_stories-lighthouse.animated #freepik--Ship--inject-2 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedLeft;animation-delay: 0s;}            @keyframes slideDown {                0% {                    opacity: 0;                    transform: translateY(-30px);                }                100% {                    opacity: 1;                    transform: translateY(0);                }            }                    @keyframes zoomIn {                0% {                    opacity: 0;                    transform: scale(0.5);                }                100% {                    opacity: 1;                    transform: scale(1);                }            }                    @keyframes slideRight {                0% {                    opacity: 0;                    transform: translateX(30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }                    @keyframes lightSpeedLeft {              from {                transform: translate3d(-50%, 0, 0) skewX(20deg);                opacity: 0;              }              60% {                transform: skewX(-10deg);                opacity: 1;              }              80% {                transform: skewX(2deg);              }              to {                opacity: 1;                transform: translate3d(0, 0, 0);              }            }        ',
        }}
      />
      <g
        id="freepik--background-complete--inject-2"
        style={{ transformOrigin: '253.8298454284668px 155.5450096130371px' }}
        className="animable"
      >
        <path
          d="M63.74,88.75l.4.73a4.93,4.93,0,0,0,2,2l.74.4-.74.4a5,5,0,0,0-2,2l-.4.73-.41-.73a4.9,4.9,0,0,0-2-2l-.74-.4.74-.4a4.84,4.84,0,0,0,2-2Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '63.7349967956543px 91.8800048828125px',
          }}
          id="el85a8uz0428r"
          className="animable"
        />
        <path
          d="M155.15,122.22l.77,1.38a9.3,9.3,0,0,0,3.72,3.69l1.4.76-1.4.76a9.3,9.3,0,0,0-3.72,3.69l-.77,1.38-.77-1.38a9.24,9.24,0,0,0-3.72-3.69l-1.4-.76,1.4-.76a9.24,9.24,0,0,0,3.72-3.69Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '155.14999389648438px 128.0500030517578px',
          }}
          id="elk9x22ize8s7"
          className="animable"
        />
        <path
          d="M453.29,249.22l.77,1.39a9.43,9.43,0,0,0,3.72,3.69l1.4.75-1.4.76a9.3,9.3,0,0,0-3.72,3.69l-.77,1.39-.76-1.39a9.3,9.3,0,0,0-3.72-3.69l-1.41-.76,1.41-.75a9.43,9.43,0,0,0,3.72-3.69Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '453.2899932861328px 255.0550079345703px',
          }}
          id="el4bl7gzl3g58"
          className="animable"
        />
        <path
          d="M131.88,62.48l.34.62a4.17,4.17,0,0,0,1.68,1.65l.63.34-.63.35a4.17,4.17,0,0,0-1.68,1.65l-.34.62-.34-.62a4.17,4.17,0,0,0-1.68-1.65l-.62-.35.62-.34a4.17,4.17,0,0,0,1.68-1.65Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '131.885009765625px 65.09499931335449px',
          }}
          id="elg94upemkz04"
          className="animable"
        />
        <path
          d="M392.1,219h48.95s-4.33-7.88-16.93-6.73c-12,1.09-12.65-3.88-18.77-4.49S394.14,211.9,392.1,219Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '416.57501220703125px 213.36358785629272px',
          }}
          id="el4s3s69on5us"
          className="animable"
        />
        <path
          d="M331.49,102.84h95.67s-8.46-15.39-33.09-13.15c-23.52,2.14-24.71-7.57-36.67-8.77S335.48,88.89,331.49,102.84Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '379.3249816894531px 91.8273696899414px',
          }}
          id="elxai1rik5y4q"
          className="animable"
        />
        <path
          d="M60.63,134.85h54.88s-4.86-8.83-19-7.54c-13.49,1.23-14.18-4.35-21-5S62.92,126.85,60.63,134.85Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '88.07000160217285px 128.55260801315308px',
          }}
          id="elt221kn587yo"
          className="animable"
        />
        <path
          d="M441.54,170.51c0,.09-1.27.43-3.19,1.38a20.77,20.77,0,0,0-6.49,5.1l-.2.23-.24.29-.2-.31a15.22,15.22,0,0,0-6-5.34c-1.85-.93-3.14-1.17-3.11-1.26a2.34,2.34,0,0,1,.91.12,12.35,12.35,0,0,1,2.37.8,14.58,14.58,0,0,1,6.24,5.38l-.44,0,.2-.24a19,19,0,0,1,6.75-5.1,15.51,15.51,0,0,1,2.42-.86A3.18,3.18,0,0,1,441.54,170.51Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '431.82474994659424px 174.00999450683594px',
          }}
          id="elcl8c1149o59"
          className="animable"
        />
        <path
          d="M63.36,161.62c0,.07-1,.33-2.45,1.06a15.71,15.71,0,0,0-5,3.91l-.15.17-.19.22-.15-.24a11.62,11.62,0,0,0-4.55-4.08c-1.42-.72-2.41-.9-2.39-1a1.78,1.78,0,0,1,.7.09,9.08,9.08,0,0,1,1.81.61,11.14,11.14,0,0,1,4.78,4.13l-.34,0,.16-.18a14.56,14.56,0,0,1,5.17-3.91,13.49,13.49,0,0,1,1.85-.66A2.35,2.35,0,0,1,63.36,161.62Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '55.919851303100586px 164.29999566078186px',
          }}
          id="elfm9eqwuc7xa"
          className="animable"
        />
        <path
          d="M108.08,186.41c0,.09-1.27.42-3.19,1.38a20.39,20.39,0,0,0-6.5,5.1l-.19.23-.24.28-.2-.31a15.25,15.25,0,0,0-6-5.33c-1.85-.93-3.14-1.17-3.11-1.27a2.89,2.89,0,0,1,.9.12,12.4,12.4,0,0,1,2.38.8,14.61,14.61,0,0,1,6.24,5.39l-.45,0,.21-.23a19,19,0,0,1,6.75-5.1,15.74,15.74,0,0,1,2.42-.87A2.6,2.6,0,0,1,108.08,186.41Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '98.36474704742432px 189.90500807762146px',
          }}
          id="elq1jnvjxffh"
          className="animable"
        />
        <path
          d="M300.78,50.2c0,.09-1.27.43-3.18,1.38a20.54,20.54,0,0,0-6.5,5.1l-.2.23-.24.29-.2-.32a15.23,15.23,0,0,0-5.94-5.33c-1.86-.93-3.15-1.17-3.12-1.27a2.94,2.94,0,0,1,.91.12,12.29,12.29,0,0,1,2.37.81,14.51,14.51,0,0,1,6.24,5.38l-.44,0,.2-.24a19,19,0,0,1,6.75-5.1,16.26,16.26,0,0,1,2.42-.86A2.8,2.8,0,0,1,300.78,50.2Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '291.0897340774536px 53.70000076293945px',
          }}
          id="el0i7fgzkivbrq"
          className="animable"
        />
        <path
          d="M420.42,137.63l.2.36a2.47,2.47,0,0,0,1,1l.36.2-.36.2a2.38,2.38,0,0,0-1,1l-.2.36-.2-.36a2.47,2.47,0,0,0-1-1l-.36-.2.36-.2a2.56,2.56,0,0,0,1-1Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '420.4200134277344px 139.19000244140625px',
          }}
          id="elablizpfzu7d"
          className="animable"
        />
        <path
          d="M59.61,239.4l.2.36a2.47,2.47,0,0,0,1,1l.36.2-.36.2a2.56,2.56,0,0,0-1,1l-.2.36-.2-.36a2.47,2.47,0,0,0-1-1l-.37-.2.37-.2a2.38,2.38,0,0,0,1-1Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '59.60500144958496px 240.95999145507812px',
          }}
          id="el3mdbajm8y9c"
          className="animable"
        />
        <path
          d="M336,186.09l.69,1.26a8.42,8.42,0,0,0,3.36,3.36l1.26.69-1.26.69a8.42,8.42,0,0,0-3.36,3.36l-.69,1.26-.69-1.26a8.49,8.49,0,0,0-3.36-3.36l-1.26-.69,1.26-.69a8.49,8.49,0,0,0,3.36-3.36Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '336px 191.39999389648438px',
          }}
          id="elz1a5wwvyq2"
          className="animable"
        />
        <path
          d="M178.11,62.52l.69,1.27a8.4,8.4,0,0,0,3.36,3.35l1.26.7-1.26.69a8.4,8.4,0,0,0-3.36,3.35l-.69,1.27-.69-1.27a8.52,8.52,0,0,0-3.36-3.35l-1.27-.69,1.27-.7a8.52,8.52,0,0,0,3.36-3.35Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '178.10499572753906px 67.83499717712402px',
          }}
          id="elqirvf317efk"
          className="animable"
        />
      </g>
      <g
        id="freepik--Sea--inject-2"
        style={{ transformOrigin: '248.55500602722168px 380.35052490234375px' }}
        className="animable"
      >
        <path
          d="M259.57,386.2s-.14.11-.44.3l-1.32.84a26.42,26.42,0,0,1-5.55,2.27,33.45,33.45,0,0,1-9.42,1.1,57.77,57.77,0,0,1-12.46-1.66c-4.54-1-9.4-2.62-14.67-4.05s-11-2.75-17.15-2.6a36.78,36.78,0,0,0-9.24,1.44,86.17,86.17,0,0,0-9.25,3.3c-3.1,1.25-6.25,2.58-9.54,3.68a40.89,40.89,0,0,1-10.32,2.2,40.47,40.47,0,0,1-10.52-.87c-3.4-.69-6.69-1.64-9.9-2.58-6.41-1.88-12.68-3.65-18.82-3.63a65.52,65.52,0,0,0-17.15,2.65c-5.28,1.43-10.12,3-14.61,4.29a86.18,86.18,0,0,1-12.27,2.7,41,41,0,0,1-9.49.18,31.81,31.81,0,0,1-5.87-1.21L60.11,394c-.33-.12-.5-.2-.5-.2s.18,0,.51.15l1.49.48a33.67,33.67,0,0,0,5.86,1.11,42.26,42.26,0,0,0,9.43-.27,88.2,88.2,0,0,0,12.21-2.77c4.47-1.28,9.31-2.9,14.59-4.35A65.66,65.66,0,0,1,121,385.45c6.23,0,12.56,1.76,19,3.63s13.17,3.84,20.25,3.42a41.06,41.06,0,0,0,10.18-2.18c3.27-1.09,6.41-2.41,9.51-3.66a87.74,87.74,0,0,1,9.31-3.3,37.34,37.34,0,0,1,9.37-1.45c6.22-.13,12,1.24,17.27,2.67s10.13,3.05,14.65,4.11a58.07,58.07,0,0,0,12.38,1.73,33.78,33.78,0,0,0,9.36-1,27.15,27.15,0,0,0,5.55-2.17l1.34-.79Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '159.59000396728516px 388.92719650268555px',
          }}
          id="elg5lvuqs3yw"
          className="animable"
        />
        <path
          d="M380.27,437.77l-.45.31-1.37.87a27.49,27.49,0,0,1-5.76,2.36,34.69,34.69,0,0,1-9.78,1.15A60.49,60.49,0,0,1,350,440.74c-4.72-1.09-9.76-2.72-15.24-4.2s-11.43-2.86-17.8-2.7a38.74,38.74,0,0,0-9.6,1.5,93.7,93.7,0,0,0-9.6,3.43c-3.22,1.3-6.48,2.68-9.9,3.83a43.12,43.12,0,0,1-10.71,2.29,42.19,42.19,0,0,1-10.92-.9c-3.54-.72-6.95-1.71-10.29-2.67-6.65-2-13.16-3.79-19.54-3.77a67.76,67.76,0,0,0-17.8,2.76c-5.48,1.48-10.51,3.14-15.16,4.46a89.61,89.61,0,0,1-12.75,2.8,43.12,43.12,0,0,1-9.85.2,34.47,34.47,0,0,1-6.1-1.26l-1.52-.55-.51-.21.53.16,1.54.49a36.34,36.34,0,0,0,6.08,1.16,43.21,43.21,0,0,0,9.79-.29,89.92,89.92,0,0,0,12.68-2.88c4.64-1.33,9.66-3,15.15-4.52A68.25,68.25,0,0,1,236.37,437c6.47,0,13,1.82,19.69,3.76s13.67,4,21,3.54a42.37,42.37,0,0,0,10.58-2.26c3.39-1.13,6.65-2.5,9.87-3.81a91.37,91.37,0,0,1,9.66-3.43,38.82,38.82,0,0,1,9.73-1.5c6.45-.15,12.46,1.28,17.93,2.76s10.52,3.16,15.21,4.27a60.9,60.9,0,0,0,12.85,1.78,35,35,0,0,0,9.72-1,29,29,0,0,0,5.77-2.26l1.39-.82C380.1,437.85,380.27,437.77,380.27,437.77Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '276.48999786376953px 440.62512254714966px',
          }}
          id="elkwsizqqz4i"
          className="animable"
        />
        <path
          d="M416.57,400.94l-.26-.09-.75-.32a27.1,27.1,0,0,0-2.94-1,33.62,33.62,0,0,0-11.36-.78c-4.83.33-10.44,1.72-16.77,2.79a50.5,50.5,0,0,1-10.07.76,42.63,42.63,0,0,1-10.64-2c-3.56-1-7-2.23-10.36-3a27.23,27.23,0,0,0-9.89-.67,33.68,33.68,0,0,0-8.61,2.63c-2.6,1.14-5,2.34-7.18,3.34a31.5,31.5,0,0,1-11,3.32,15,15,0,0,1-3.13-.11l-.81-.12a1,1,0,0,1-.27-.06h.28l.81.06a17.23,17.23,0,0,0,3.1,0,32.37,32.37,0,0,0,10.83-3.46c2.2-1,4.56-2.24,7.17-3.4a33.3,33.3,0,0,1,8.73-2.72,27.5,27.5,0,0,1,10.07.65c3.42.77,6.85,2,10.39,3a43,43,0,0,0,10.52,2,50.46,50.46,0,0,0,10-.73c6.3-1,11.95-2.39,16.83-2.67a32.52,32.52,0,0,1,11.43.95A17.81,17.81,0,0,1,416.57,400.94Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '364.55003356933594px 400.93415451049805px',
          }}
          id="elmid86q8yb1g"
          className="animable"
        />
        <path
          d="M475.17,313c0,.15-101.46.26-226.6.26S21.94,313.17,21.94,313s101.44-.26,226.63-.26S475.17,312.88,475.17,313Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '248.55500602722168px 313px',
          }}
          id="eld8pzqggqiou"
          className="animable"
        />
      </g>
      <g
        id="freepik--Lighthouse--inject-2"
        style={{ transformOrigin: '219.18651008605957px 224.22738647460938px' }}
        className="animable"
      >
        <polygon
          points="235.41 99.54 26.03 312.65 156.21 312.61 235.41 126.21 235.41 99.54"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '130.72000312805176px 206.0949935913086px',
          }}
          id="elhj7l1ach96"
          className="animable"
        />
        <g id="el45ix1m1vi7s">
          <polygon
            points="235.41 99.54 26.03 312.65 156.21 312.61 235.41 126.21 235.41 99.54"
            style={{
              fill: 'rgb(255, 255, 255)',
              opacity: '0.9',
              transformOrigin: '130.72000312805176px 206.0949935913086px',
            }}
            className="animable"
          />
        </g>
        <path
          d="M184.13,349.69c19.52.92,39.43,1.9,57.6,7.38,7.08,2.13,14.15,5,21.76,4.8,11.43-.29,21.28-7.39,32.71-7.14,10.14.22,18.67,6.17,28.73,7.14,11.87,1.14,22.82-4.78,34.62-6.31,16.65-2.16,34.47,5.47,50.29.6,6.3-1.94-.61-5.19-6.25-5.33,0,0-20.88-.28-26.52-4.37s-10-4.57-13.28-5.53-8.59,1.16-8.59,1.16l-65,.84L241.36,339l-43.56,2.48Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '298.23651123046875px 350.5073833465576px',
          }}
          id="el146zj1f03hx9"
          className="animable"
        />
        <polygon
          points="228.35 155.59 223.35 316.8 285.63 316.05 280.17 155.59 228.35 155.59"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '254.49000549316406px 236.1949920654297px',
          }}
          id="eljv60fdrhc3"
          className="animable"
        />
        <rect
          x="223.35"
          y="148.56"
          width="61.08"
          height="7.03"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '253.89px 152.075px',
          }}
          id="elwo1k4008y6"
          className="animable"
        />
        <polygon
          points="235.41 148.56 235.41 99.08 252.06 91.83 256.07 91.83 273.02 99.54 273.02 148.56 235.41 148.56"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '254.21499633789062px 120.19499969482422px',
          }}
          id="el54aso2soh48"
          className="animable"
        />
        <rect
          x="235.41"
          y="99.54"
          width="37.62"
          height="26.67"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '254.22px 112.875px',
          }}
          id="elz8awt0s5xtg"
          className="animable"
        />
        <polyline
          points="252.06 91.83 252.06 86.44 255.76 86.44 255.76 91.83 252.68 91.83"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '253.90999603271484px 89.13500213623047px',
          }}
          id="el79zhok4nl4q"
          className="animable"
        />
        <g id="elp7kuxf6zjs">
          <polygon
            points="281.55 195.98 227.1 195.98 225.95 232.67 282.79 232.67 281.55 195.98"
            style={{
              fill: 'rgb(255, 255, 255)',
              opacity: '0.4',
              transformOrigin: '254.37000274658203px 214.3249969482422px',
            }}
            className="animable"
          />
        </g>
        <path
          d="M277.75,148.56a3.86,3.86,0,0,1-.05-.59c0-.44,0-1-.05-1.71,0-1.55,0-3.69-.08-6.34l.18.19c-5.85,0-14.36.08-23.82.08s-18,0-23.83-.08l.19-.19c0,2.65-.06,4.79-.08,6.34,0,.7,0,1.27-.05,1.71a2.27,2.27,0,0,1-.06.59,3.86,3.86,0,0,1,0-.59c0-.44,0-1-.05-1.71,0-1.55-.05-3.69-.08-6.34v-.18h.18c5.86-.06,14.37-.09,23.83-.09s18,0,23.82.09h.19v.18c0,2.65-.06,4.79-.08,6.34,0,.7,0,1.27-.05,1.71A2.27,2.27,0,0,1,277.75,148.56Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '253.98001861572266px 144.1050033569336px',
          }}
          id="elnhg65cb72z7"
          className="animable"
        />
        <path
          d="M264.18,148.56a17.44,17.44,0,0,1-.27-4.32,17.5,17.5,0,0,1,.27-4.32,17.5,17.5,0,0,1,.27,4.32A17.44,17.44,0,0,1,264.18,148.56Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '264.17997339367867px 144.23999786376953px',
          }}
          id="elhp88rwntlx7"
          className="animable"
        />
        <path
          d="M246.58,148.56a17.44,17.44,0,0,1-.27-4.32,17.5,17.5,0,0,1,.27-4.32,17.2,17.2,0,0,1,.28,4.32A17.13,17.13,0,0,1,246.58,148.56Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '246.5846924185753px 144.239990234375px',
          }}
          id="elcr5z82av7tu"
          className="animable"
        />
        <path
          d="M246.25,126.21c-.15,0-.27-6-.27-13.34s.12-13.33.27-13.33.28,6,.28,13.33S246.4,126.21,246.25,126.21Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '246.25499725341797px 112.87499618530273px',
          }}
          id="elbbibektybi"
          className="animable"
        />
        <path
          d="M261,126.21c-.15,0-.27-6-.27-13.34s.12-13.33.27-13.33.28,6,.28,13.33S261.18,126.21,261,126.21Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '261.0050048828125px 112.87499618530273px',
          }}
          id="elrt5pedvqrm"
          className="animable"
        />
        <path
          d="M273,112.94a7.23,7.23,0,0,1-1.47.12l-4,.12c-3.41.07-8.11.14-13.3.16s-9.9,0-13.31-.07a30.18,30.18,0,0,1-5.5-.33l18.8-.15h13.3l4,0A7.48,7.48,0,0,1,273,112.94Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '254.2100067138672px 113.06868627667427px',
          }}
          id="elrpqjl2llvc"
          className="animable"
        />
        <g id="elxkhjte5rj9">
          <polygon
            points="224.76 271.07 284.1 271.07 285.35 307.92 223.62 307.67 224.76 271.07"
            style={{
              fill: 'rgb(255, 255, 255)',
              opacity: '0.4',
              transformOrigin: '254.48500061035156px 289.49501037597656px',
            }}
            className="animable"
          />
        </g>
        <path
          d="M227.66,182.59a21.22,21.22,0,0,1,3.27-.18c2,0,4.91-.08,8.15-.09l-.27.27V178l.27.26c-3.24,0-6.1,0-8.15-.09a24.16,24.16,0,0,1-3.27-.17,21.22,21.22,0,0,1,3.27-.18c2,0,4.91-.08,8.15-.09h.27v5.14h-.27c-3.24,0-6.1,0-8.15-.09A21.22,21.22,0,0,1,227.66,182.59Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '233.5050048828125px 180.30001068115234px',
          }}
          id="el68a82l4azyi"
          className="animable"
        />
        <path
          d="M258.34,133a6.47,6.47,0,0,1-.09-1.17c0-.79-.08-2-.1-3.42v-.19h.2c2.89-.05,6.94-.08,11.42-.08l.28.28h0v1.18c0,.39,0,.78,0,1.17,0,.77,0,1.51,0,2.23v.26h-.26c-3.37,0-6.26-.07-8.28-.12l-2.35-.07a3.84,3.84,0,0,1-.79-.07,6.87,6.87,0,0,1,.91-.07l2.4-.07c2-.05,4.86-.11,8.11-.12l-.26.26c0-.72,0-1.46,0-2.23V128.4h0c-.06-.06.52.51.27.27-4.48,0-8.53,0-11.42-.08l.19-.19c0,1.37-.07,2.5-.1,3.3S258.36,133,258.34,133Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '264.1000061035156px 130.69998931884766px',
          }}
          id="elxvqdfo6g078"
          className="animable"
        />
        <path
          d="M251.63,137.66a7.25,7.25,0,0,1-.08-1.17c0-.78-.08-2-.11-3.42v-.19h.19c2.9,0,6.95-.08,11.43-.08l.27.27h0v2.34c0,.77,0,1.52,0,2.23v.27h-.26c-3.37,0-6.27-.08-8.29-.13l-2.34-.07a2.69,2.69,0,0,1-.8-.07,6.52,6.52,0,0,1,.92-.06l2.4-.07c2-.05,4.85-.11,8.11-.13l-.26.26c0-.71,0-1.46,0-2.23v-2.34h0l.27.27c-4.48,0-8.53,0-11.43-.08l.2-.19c0,1.38-.07,2.51-.11,3.31A8,8,0,0,1,251.63,137.66Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '257.38499450683594px 135.3550033569336px',
          }}
          id="eldn9gtprsm7q"
          className="animable"
        />
        <path
          d="M225,260.68a21.44,21.44,0,0,1,3.28-.18c2.05-.05,4.9-.08,8.15-.09l-.27.27c0-.74,0-1.51,0-2.3s0-1.56,0-2.3l.27.27c-3.25,0-6.1,0-8.15-.09a21.44,21.44,0,0,1-3.28-.18,22.48,22.48,0,0,1,3.28-.17c2.05,0,4.9-.09,8.15-.1h.27V261h-.27c-3.25,0-6.1-.05-8.15-.09A21.44,21.44,0,0,1,225,260.68Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '230.8499984741211px 258.4050064086914px',
          }}
          id="el3jsuayn8sag"
          className="animable"
        />
        <path
          d="M246.58,187.63a13.16,13.16,0,0,1-.08-1.39c0-.88-.08-2.12-.1-3.65l.18.19c-3.41.05-8.38.08-13.9.08l.27-.27h0v2.57c0,.84,0,1.66,0,2.45l-.26-.26c4,0,7.39.07,9.87.12l2.93.08a8.8,8.8,0,0,1,1.1.06,4.75,4.75,0,0,1-1,.07l-2.87.07c-2.46,0-6,.11-10,.13h-.26v-5.29h0c-.05.06.52-.52.28-.27,5.52,0,10.49,0,13.9.09h.19v.18c0,1.62-.07,2.9-.1,3.76A7.66,7.66,0,0,1,246.58,187.63Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '239.64343881607056px 185.06858921051025px',
          }}
          id="elbm4l8zpnknf"
          className="animable"
        />
        <path
          d="M260.86,246.31a13.52,13.52,0,0,1-.08-1.4c0-.87-.08-2.11-.1-3.64l.18.18c-3.42.06-8.39.09-13.9.09l.27-.27h0v2.56c0,.85,0,1.67,0,2.46l-.27-.26c4,0,7.4.07,9.88.12l2.93.07a9.86,9.86,0,0,1,1.1.07,6.13,6.13,0,0,1-1,.07l-2.87.07c-2.46.05-6,.11-10.06.12h-.26v-.26c0-.79,0-1.61,0-2.46v-2.56h0L247,241c5.51,0,10.48,0,13.9.09h.19v.18c0,1.61-.07,2.89-.11,3.75A7.44,7.44,0,0,1,260.86,246.31Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '253.88500213623047px 243.77500915527344px',
          }}
          id="elmvhb1pit9q"
          className="animable"
        />
        <path
          d="M242.73,265.72a13.52,13.52,0,0,1-.08-1.4c0-.87-.08-2.11-.1-3.64l.18.18c-3.41.06-8.38.09-13.9.09l.27-.27h0v2.56c0,.85,0,1.67,0,2.46l-.26-.26c4,0,7.39.07,9.87.12l2.93.07a9.86,9.86,0,0,1,1.1.07,6,6,0,0,1-1,.07l-2.87.07c-2.46.05-6,.11-10,.12h-.26V260.7h0c-.06.06.52-.52.28-.27,5.52,0,10.49,0,13.9.08h.19v.18c0,1.61-.07,2.9-.1,3.75A7.89,7.89,0,0,1,242.73,265.72Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '235.79280996322632px 263.163560628891px',
          }}
          id="elv1dc9iyfos9"
          className="animable"
        />
        <path
          d="M276.29,291.77a11.47,11.47,0,0,1-.09-1.4c0-.87-.07-2.11-.1-3.64l.19.18c-3.42.06-8.39.09-13.91.09l.27-.27h0v2.57c0,.84,0,1.66,0,2.45l-.26-.26c4,0,7.4.07,9.88.12l2.92.07a9.94,9.94,0,0,1,1.11.07,6.38,6.38,0,0,1-1,.07l-2.86.07c-2.47,0-6,.11-10.06.12h-.26v-.26c0-.79,0-1.61,0-2.45v-2.57h0l.27-.27c5.52,0,10.49,0,13.91.08h.18v.18c0,1.61-.07,2.9-.1,3.76A8.8,8.8,0,0,1,276.29,291.77Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '269.29998779296875px 289.23500061035156px',
          }}
          id="elg8e4lyiqwbi"
          className="animable"
        />
        <path
          d="M285.05,297a13.16,13.16,0,0,1-.08-1.39c0-.88-.08-2.12-.1-3.65l.18.19c-3.42.05-8.39.09-13.9.09-.25.24.33-.34.27-.28h0v2.57c0,.84,0,1.66,0,2.45l-.26-.26c4,0,7.39.07,9.87.12L284,297a8.8,8.8,0,0,1,1.1.06,4.05,4.05,0,0,1-1,.07l-2.87.07c-2.46.06-6,.11-10.05.13h-.27V297c0-.79,0-1.61,0-2.45V292h0l.28-.27c5.51,0,10.48,0,13.9.09h.19V292c0,1.62-.07,2.9-.1,3.76A7.66,7.66,0,0,1,285.05,297Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '278.09503173828125px 294.53001403808594px',
          }}
          id="eljal676bsns"
          className="animable"
        />
        <path
          d="M274.57,211.69a11.4,11.4,0,0,1-.09-1.39c0-.88-.08-2.12-.1-3.65l.18.19c-3.41,0-8.38.09-13.9.09l.27-.28h0v2.57c0,.84,0,1.66,0,2.45l-.26-.26c4,0,7.4.07,9.87.12l2.93.08a9.29,9.29,0,0,1,1.11.06,4.2,4.2,0,0,1-1,.07l-2.86.07c-2.47.06-6,.11-10.06.13h-.26v-.27c0-.79,0-1.61,0-2.45v-2.57h0c-.06.06.51-.52.27-.27,5.52,0,10.49,0,13.9.09h.19v.18c0,1.62-.07,2.9-.1,3.76A8.8,8.8,0,0,1,274.57,211.69Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '267.5777277946472px 209.12857913970947px',
          }}
          id="el0mncd6yx5ohf"
          className="animable"
        />
        <g id="el3ohaba1s8yp">
          <polygon
            points="228.35 155.59 264.18 163.67 266.85 316.05 285.63 316.05 280.17 155.59 228.35 155.59"
            style={{
              opacity: '0.4',
              transformOrigin: '256.99000549316406px 235.8199920654297px',
            }}
            className="animable"
          />
        </g>
        <path
          d="M203,337.28c0,.16-12,.28-26.75.28s-26.76-.12-26.76-.28,12-.27,26.76-.27S203,337.13,203,337.28Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '176.24500274658203px 337.2850036621094px',
          }}
          id="els37tcg7r9vm"
          className="animable"
        />
        <path
          d="M313.67,315.93a9.74,9.74,0,0,1-1.71.37l-4.69.8c-4,.64-9.45,1.5-15.51,2.42l-2.36.35.16-.08-6.42,6.85-.05.06H283l-7.5,1.07-2.09.26a2.66,2.66,0,0,1-.75,0,3.61,3.61,0,0,1,.72-.18l2.08-.39,7.47-1.25-.13.07,6.35-6.91.06-.07h.1l2.36-.36c6.06-.92,11.55-1.72,15.53-2.27l4.72-.62A11.68,11.68,0,0,1,313.67,315.93Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '293.16502380371094px 321.9931683540344px',
          }}
          id="elg4iaifjh50c"
          className="animable"
        />
        <path
          d="M170.7,324.82a7.46,7.46,0,0,1,4.64-.57,3.81,3.81,0,0,1,2.29,1,1.65,1.65,0,0,1,0,2.29,2.17,2.17,0,0,1-1.44.36c-1.23,0-2.59-.23-3.57.51-.56.42-.93,1.12-1.6,1.33a1.59,1.59,0,0,1-1.74-.77,2.71,2.71,0,0,1-.2-2A3.06,3.06,0,0,1,170.7,324.82Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '173.53309631347656px 326.94330739974976px',
          }}
          id="elmeo0uvjb43"
          className="animable"
        />
        <path
          d="M167.46,318.57a2.22,2.22,0,0,0,3.32.08,6.32,6.32,0,0,0,1.41-2.89c.68-2.37,1.37-4.87.86-7.29a4,4,0,0,0-.93-2,2.13,2.13,0,0,0-2-.67,3.14,3.14,0,0,0-1.76,1.84,17.52,17.52,0,0,0-1.71,7.46,6,6,0,0,0,.81,3.45"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '169.9311273097992px 312.55830812454224px',
          }}
          id="el0ihzr0apgui"
          className="animable"
        />
        <path
          d="M165.09,320.34a4.47,4.47,0,0,0,.7-4.13,8,8,0,0,0-2.44-3.54,13.23,13.23,0,0,0-4.38-2.59,4.78,4.78,0,0,0-2-.33,2.09,2.09,0,0,0-1.66,1,3.11,3.11,0,0,0,.46,2.81,33.76,33.76,0,0,0,2.88,4.38,7.78,7.78,0,0,0,3.16,2.71c1.32.51,2.68.45,3.38-.46"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '160.58763599395752px 315.35727739334106px',
          }}
          id="el08h1pm7fje2w"
          className="animable"
        />
        <path
          d="M167.4,337.17a2,2,0,0,0,.08-.56l.15-1.53a21.51,21.51,0,0,1,.35-2.24,16.48,16.48,0,0,1,.81-2.65,9.8,9.8,0,0,1,1.35-2.39,5.21,5.21,0,0,1,1.71-1.42,4.86,4.86,0,0,1,1.44-.45,2.66,2.66,0,0,0,.56-.08,2.28,2.28,0,0,0-.57,0,4.36,4.36,0,0,0-1.5.39,5.07,5.07,0,0,0-1.8,1.43,9.23,9.23,0,0,0-1.4,2.45,15.63,15.63,0,0,0-.81,2.69,18.77,18.77,0,0,0-.3,2.27c-.05.65-.07,1.17-.08,1.54A3,3,0,0,0,167.4,337.17Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '170.61594128608704px 331.5010643005371px',
          }}
          id="eljcw1pbwrwtj"
          className="animable"
        />
        <path
          d="M167.51,336a1,1,0,0,0,0-.26V335c0-.64,0-1.58,0-2.73.05-2.3.25-4.79.63-8.28.37-3.29.86-7.12,1.37-9.61.11-.57.22-1.08.33-1.52s.18-.84.26-1.15.13-.53.18-.72a1.19,1.19,0,0,0,0-.26,1.12,1.12,0,0,0-.09.25c-.06.18-.13.42-.21.71s-.2.69-.31,1.14-.24.95-.36,1.51a82.6,82.6,0,0,0-1.43,8.92c-.39,3.5-.56,6.7-.58,9,0,1.15,0,2.09,0,2.73,0,.31,0,.55,0,.75A.9.9,0,0,0,167.51,336Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '168.7935438156128px 323.36500549316406px',
          }}
          id="elxk1gzcutub8"
          className="animable"
        />
        <path
          d="M167.53,329.84a6.62,6.62,0,0,0,0-.78c0-.5-.1-1.22-.24-2.1a29.91,29.91,0,0,0-.68-3.07,25.68,25.68,0,0,0-1.28-3.62,19.19,19.19,0,0,0-3.77-5.86,9.33,9.33,0,0,0-.88-.83c-.14-.11-.26-.23-.38-.32l-.35-.23a3.52,3.52,0,0,0-.65-.42,21.56,21.56,0,0,1,2.14,1.91,20.07,20.07,0,0,1,3.67,5.84,28.82,28.82,0,0,1,1.29,3.59,30.35,30.35,0,0,1,.73,3c.16.87.25,1.59.31,2.08A4.46,4.46,0,0,0,167.53,329.84Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '163.42073345184326px 321.22499084472656px',
          }}
          id="elg4z7ki8i8sq"
          className="animable"
        />
        <rect
          x="230.1"
          y="205.46"
          width="4.03"
          height="6.23"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '232.11499999999998px 208.57500000000002px',
          }}
          id="el23qgu64igp5"
          className="animable"
        />
        <rect
          x="230.1"
          y="213.4"
          width="4.03"
          height="6.23"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '232.11499999999998px 216.51500000000001px',
          }}
          id="elz6v2criqll"
          className="animable"
        />
        <path
          d="M303.15,303.7c.05-1.58,1.44-2.78,2.83-3.53s3-1.33,3.94-2.57c1.58-2,1.22-5.34,3.33-6.79,1.24-.85,3-.75,4.15-1.71a6.39,6.39,0,0,0,1.35-1.93,22.69,22.69,0,0,1,8.36-8.54,19.64,19.64,0,0,1-5,9.13,13,13,0,0,0-2.7,3.24c-1,2.07-.41,4.66-1.56,6.64-1.33,2.26-4.54,3.09-5.4,5.56-.73,2.09.57,4.5-.18,6.58a6.13,6.13,0,0,1-1.68,2.24c-2.44,2.25-5.4,3.42-9,2.3l-4.52-1.15Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '312.0899658203125px 296.6902484893799px',
          }}
          id="ell823jyonrn"
          className="animable"
        />
        <g id="el86x19syhg0i">
          <g
            style={{
              opacity: '0.30000000000000004',
              transformOrigin: '312.0899658203125px 296.6902484893799px',
            }}
            className="animable"
          >
            <path
              d="M303.15,303.7c.05-1.58,1.44-2.78,2.83-3.53s3-1.33,3.94-2.57c1.58-2,1.22-5.34,3.33-6.79,1.24-.85,3-.75,4.15-1.71a6.39,6.39,0,0,0,1.35-1.93,22.69,22.69,0,0,1,8.36-8.54,19.64,19.64,0,0,1-5,9.13,13,13,0,0,0-2.7,3.24c-1,2.07-.41,4.66-1.56,6.64-1.33,2.26-4.54,3.09-5.4,5.56-.73,2.09.57,4.5-.18,6.58a6.13,6.13,0,0,1-1.68,2.24c-2.44,2.25-5.4,3.42-9,2.3l-4.52-1.15Z"
              id="elc2th7b0461o"
              style={{
                transformOrigin: '312.0899658203125px 296.6902484893799px',
              }}
              className="animable"
            />
          </g>
        </g>
        <path
          d="M296.13,313a3.51,3.51,0,0,1-1.23-.36,7.19,7.19,0,0,1-2.89-2.3,2.53,2.53,0,0,1-.46-1.22,5,5,0,0,1,.17-1.42,5.28,5.28,0,0,0,.18-3,11.63,11.63,0,0,1-.8-3.58,10.65,10.65,0,0,1,1.26-3.92,8.51,8.51,0,0,0,1.11-4.19c-.07-1.52-.69-3.07-.72-4.82s.71-3.42,1.09-5.13a6.75,6.75,0,0,0,.14-2.61c-.13-.89-.42-1.78-.57-2.74a18.07,18.07,0,0,1,.44-5.85c.17-1,.34-2,.51-2.95a14.43,14.43,0,0,0,.34-3,27.3,27.3,0,0,0-.27-3.07,10.63,10.63,0,0,1-.09-1.62,15.64,15.64,0,0,1,.3-1.6,35.25,35.25,0,0,1,2.35-6.05l.08-.17.15-.36.28.26a8.9,8.9,0,0,1,2.54,6,34.31,34.31,0,0,1-.32,6.29,16.36,16.36,0,0,0,.26,5.9c.49,1.84,1.55,3.65,1.29,5.69s-1.83,3.38-2.09,5.08.38,3.36.87,4.94a8.72,8.72,0,0,1,.49,4.87c-.34,1.56-1,2.93-1.26,4.3a10.18,10.18,0,0,0,0,4c.21,1.25.52,2.42.74,3.54a9.68,9.68,0,0,1,.24,3.17,9.22,9.22,0,0,1-.73,2.58,6.75,6.75,0,0,1-2.26,2.89,3.13,3.13,0,0,1-1.17.53,8.69,8.69,0,0,0,1.11-.62,6.79,6.79,0,0,0,2.12-2.88A9.17,9.17,0,0,0,300,307a9.05,9.05,0,0,0-.28-3.08c-.23-1.1-.55-2.27-.78-3.54a10.48,10.48,0,0,1-.06-4.11c.28-1.43.91-2.81,1.22-4.3a8.39,8.39,0,0,0-.51-4.65c-.26-.79-.55-1.6-.76-2.46a6.31,6.31,0,0,1-.15-2.71c.32-1.89,1.84-3.27,2.07-5.05s-.77-3.57-1.31-5.49a17,17,0,0,1-.28-6.09,33.78,33.78,0,0,0,.31-6.2,8.39,8.39,0,0,0-2.37-5.62l.44-.1-.07.18a34.11,34.11,0,0,0-2.33,6,14.8,14.8,0,0,0-.29,1.51,8.79,8.79,0,0,0,.09,1.52,25.08,25.08,0,0,1,.26,3.13,14.18,14.18,0,0,1-.35,3.08c-.17,1-.34,2-.51,2.95a17.64,17.64,0,0,0-.46,5.68c.14.91.42,1.81.55,2.74a7.29,7.29,0,0,1-.15,2.8c-.42,1.77-1.13,3.38-1.11,5s.62,3.19.69,4.8a8.87,8.87,0,0,1-1.18,4.37,10.47,10.47,0,0,0-1.26,3.78,11.21,11.21,0,0,0,.75,3.48,4.42,4.42,0,0,1,.11,1.69,12.28,12.28,0,0,1-.34,1.5,5,5,0,0,0-.19,1.33,2.56,2.56,0,0,0,.41,1.13,7.35,7.35,0,0,0,2.75,2.31A7.87,7.87,0,0,0,296.13,313Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '296.205228805542px 283.0600051879883px',
          }}
          id="elx7lsqp765g"
          className="animable"
        />
        <path
          d="M297.38,256.17c.05,0,0,.8,0,2.23,0,.36,0,.75.07,1.18s.12.91.17,1.43a33.27,33.27,0,0,1,.15,3.49c0,1.29-.08,2.71-.17,4.22a17.07,17.07,0,0,0,.17,4.76c.15.83.35,1.69.45,2.6a11.35,11.35,0,0,1-.11,2.79c-.06.46-.13.92-.2,1.39s-.09.94-.13,1.41c-.09.95-.18,1.91-.27,2.89-.39,7.85-.65,15-.87,20.13-.12,2.51-.22,4.58-.29,6.1-.05.67-.08,1.21-.11,1.65a2.1,2.1,0,0,1-.08.58,2.17,2.17,0,0,1,0-.58v-1.66c0-1.52.07-3.59.12-6.11.12-5.15.32-12.28.72-20.15q.13-1.47.27-2.91c0-.48.09-1,.13-1.43l.21-1.39a10.35,10.35,0,0,0,.12-2.65c-.09-.87-.28-1.72-.43-2.56a17.23,17.23,0,0,1-.12-4.89c.11-1.51.21-2.91.24-4.2s0-2.44-.08-3.46c0-.51-.08-1-.12-1.42s0-.85,0-1.21a14.73,14.73,0,0,1,.15-1.66A1.77,1.77,0,0,1,297.38,256.17Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '297.2002795934677px 284.59503173828125px',
          }}
          id="el0dd5qwtyu8hl"
          className="animable"
        />
        <path
          d="M295.34,312.8c-2.42-2.59-1.72-8.11.43-10.92s5.12-5.1,6.44-8.39c1-2.53.94-5.45,2.29-7.81,1.82-3.2,5.95-4.88,6.94-8.42.55-2,0-4.18.64-6.13.81-2.39,3.24-3.77,5-5.57,2.72-2.76,4-6.59,5.64-10.08s4.22-7,8-7.87c-.43,3.26-.24,5.63-1.72,9.77-.54,1.49-3.14,3.87-4.35,7.12-.72,1.95-1.4,3.91-2.1,5.86a20.31,20.31,0,0,1-2.61,5.43c-.93,1.23-2.15,2.24-3,3.56-1.53,2.47-1.41,5.67-2.8,8.22-1.18,2.16-3.36,3.68-4.37,5.93-1.42,3.16-.29,7.2-2.29,10-1,1.4-2.64,2.28-3.48,3.78-.64,1.16-.72,2.57-1.34,3.75-1,1.9-5.31,2.35-7.33,1.62"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '312.26773262023926px 280.2954788208008px',
          }}
          id="elmz5ffuscr8r"
          className="animable"
        />
        <path
          d="M329,250.47a3.83,3.83,0,0,1-.26.67c-.19.44-.45,1.08-.85,1.89s-1.13,1.67-1.81,2.73a42.19,42.19,0,0,0-2.22,3.69c-.77,1.41-1.53,3-2.34,4.69a21.62,21.62,0,0,1-3.13,5.18c-.69.82-1.42,1.62-2.05,2.51a13.54,13.54,0,0,0-1.52,3l-.63,1.62-.73,1.63-1.5,3.31c-2.2,4.37-4.35,8.51-6.32,12.28l-5.29,9.94-3.6,6.69-1,1.8a4.82,4.82,0,0,1-.38.61,3.37,3.37,0,0,1,.28-.66c.24-.47.54-1.09.92-1.85.84-1.66,2-4,3.45-6.77s3.24-6.25,5.19-10,4-7.92,6.27-12.28l1.49-3.29.73-1.6.63-1.63a13.91,13.91,0,0,1,1.6-3.06c.66-.92,1.4-1.73,2.08-2.53a21.53,21.53,0,0,0,3.11-5.06c.83-1.69,1.61-3.27,2.41-4.67a40.73,40.73,0,0,1,2.3-3.68c.72-1.06,1.46-1.88,1.89-2.66s.69-1.37.93-1.83A3.38,3.38,0,0,1,329,250.47Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '312.1849670410156px 281.5899658203125px',
          }}
          id="elbo2fbz2nzx6"
          className="animable"
        />
        <path
          d="M310.49,351.23a33.16,33.16,0,0,0,22.14-1.59,25.66,25.66,0,0,1,5.13-1.68c8.86-1.75,17.65,3.46,26.69,3.55,5.42.05,10.66-1.73,16-2.66-4.79-3.37-10.69-7.48-10.69-7.48l-1.54-3.72-13.29-4-15.75-10.25L329.29,322l-10.82-5.76-32.84-5.66H222.11l-17.78,11.12L166,323.86l-16.42,12.95-24.15,6.44-10.65,8.06a64.42,64.42,0,0,0,8.1.25c13.71-.53,26.91-6.65,40.62-6,14.79.68,28.89,9.2,43.56,7.2,11.68-1.59,22.24-9.75,34-8.81,10.94.87,20.29,9.55,31.26,9.57,6.47,0,12.49-3,18.72-4.75C298.25,346.72,303.08,349.12,310.49,351.23Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '247.61500549316406px 332.0500030517578px',
          }}
          id="el7xaqaea57cw"
          className="animable"
        />
      </g>
      <g
        id="freepik--Ship--inject-2"
        style={{ transformOrigin: '404.71498107910156px 306.35997009277344px' }}
        className="animable"
      >
        <path
          d="M425.46,317.17c0,.12-8.55.22-19.1.22s-19.1-.1-19.1-.22,8.55-.22,19.1-.22S425.46,317.05,425.46,317.17Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '406.3599853515625px 317.1700134277344px',
          }}
          id="elfzg5otg4aga"
          className="animable"
        />
        <path
          d="M419.55,321.52c0,.13-5.48.23-12.24.23s-12.24-.1-12.24-.23,5.48-.22,12.24-.22S419.55,321.4,419.55,321.52Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '407.30999755859375px 321.5249938964844px',
          }}
          id="elsp2ikdapeo"
          className="animable"
        />
        <path
          d="M409.58,326.21a8.23,8.23,0,0,1-3.78,0,8.23,8.23,0,0,1,3.78,0Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '407.6899871826172px 326.2099952697754px',
          }}
          id="elkd89zj8rocc"
          className="animable"
        />
        <path
          d="M416.39,303.66V292.4h-9.11v-6.11h-2.56v6.41h-1.34v-6.35h-2.25v6H387.21v1.84h1.93c-.07,1-.12,3-.12,5.27,0,1.59,0,3,.06,4.1l-9.76.05,8.6,9.52h35.43l6.76-9.52Zm-27-9.42h4.38c-.07,1-.12,3-.12,5.27,0,1.58,0,3,.06,4.07l-4.26,0c0-1.08.06-2.51.06-4.1C389.49,297.23,389.44,295.25,389.37,294.24Zm10,9.32-5.35,0c0-1.07.06-2.49.06-4.07,0-2.28-.05-4.26-.13-5.27h5.42Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '404.71498107910156px 299.7099914550781px',
          }}
          id="elh1tvdtsjw74"
          className="animable"
        />
      </g>
      <defs>
        <filter id="active" height="200%">
          <feMorphology
            in="SourceAlpha"
            result="DILATED"
            operator="dilate"
            radius={2}
          />
          <feFlood floodColor="#32DFEC" floodOpacity={1} result="PINK" />
          <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
          <feMerge>
            <feMergeNode in="OUTLINE" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
        <filter id="hover" height="200%">
          <feMorphology
            in="SourceAlpha"
            result="DILATED"
            operator="dilate"
            radius={2}
          />
          <feFlood floodColor="#ff0000" floodOpacity="0.5" result="PINK" />
          <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
          <feMerge>
            <feMergeNode in="OUTLINE" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
          <feColorMatrix
            type="matrix"
            values="0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
          />
        </filter>
      </defs>
    </svg>
  );
};

export default LowersIcons;

LowersIcons.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
};
